export const parseListToFileList = (value: FileList | File[] | Blob[] | null) => {
    if (value === null) return null;
    if (value instanceof FileList) return value;

    const container = new DataTransfer();

    value.forEach((v, i) => {
        let file: File;
        if (v instanceof File) {
            file = v;
        } else {
            file = new File([v], `FileNumber${i}`, { type: v.type, lastModified: new Date().getTime() });
        }
        container.items.add(file);
    })

    return container.files;
}

export const filterFiles = (value: FileList | File[], predicate: (v: File, i: number) => boolean) => {
    var list = Array.from(value).filter((f, i) => predicate(f, i));
    return parseListToFileList(list)!;
}

export const isFileOfType = (value: File, accept?: string) => {
    if (!accept) return true;
    const acceptList = accept.split(/[ ,]+/);
    return acceptList.includes(value.type);
}

export const handleSetInputValue = (input: HTMLInputElement, value: FileList | File[] | Blob[] | null, fireEvent = false) => {
    if (value == null) {
        input.files = null;
        input.value = "";
        return;
    }

    let filteredFileList = filterFiles(parseListToFileList(value)!, f => isFileOfType(f, input.accept));
    if (!input.multiple) filteredFileList = filterFiles(filteredFileList, (_, i) => i === 0);
    input.files = filteredFileList;

    if (fireEvent) {
        const event = new Event("change", { bubbles: true });
        input.dispatchEvent(event);
    }
}